var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 40,
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41746 0.611572C1.15289 0.611572 0.888322 0.878079 0.888322 1.14459C0.888322 1.41109 1.02061 1.54435 1.15289 1.6776C11.2066 6.07497 15.8366 17.9345 11.3389 28.0618C9.3546 32.7257 5.6506 36.3235 1.15289 38.3223C0.888321 38.4556 0.756037 38.8553 0.888322 39.1218C1.02061 39.3883 1.15289 39.3883 1.41746 39.3883H19.6729V0.611572H1.41746Z",
    fill: "#0284C7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.f3213e9c88d3d89c732fa711588a6593.svg";
export { ForwardRef as ReactComponent };